import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('readyStatusBadge');

    return {
        READY: t('ready')
    };
};

export default useTranslation;
